<template>
    <v-card min-width="25vw" align="center" justify="center" light outlined>
        <v-card-title style="background-color: #d2d7e1">
            <v-list-item>
                <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-5 pt-5">
           <v-container fluid>
              <v-row class="my-2">
                <div>
                  <p>{{ $t('prependMessage') }} <b>{{ this.referred }}</b> {{ $t('appendMessage') }}</p>
                </div>
              </v-row>
              <v-row class="my-2" align="center" justify="center">
                  <v-btn @click="closeWindow">{{ $t('btnCancel') }}</v-btn>
              </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        referred: String,
    },
    name: "ReferredError",
    methods: {
        closeWindow() {
            this.$emit('closeWindow');
        }
    }
}
</script>

<i18n>
{
  "en": {
    "title": "Error adding referred",
    "prependMessage": "Referred",
    "appendMessage": "doesn't exist.",
    "btnCancel": "Cancel"
  },
  "es": {
    "title": "Error al agregar referido",
    "prependMessage": "El referido",
    "appendMessage": "no existe.",
    "btnCancel": "Cancelar"
  }
}
</i18n>

<style>

</style>
